<script setup>
import { defineProps, ref, computed } from 'vue'
import { goToTournament } from '@/services/utils'

const props = defineProps({
  tournaments: {
    type: Array,
    default: () => []
  }
})

const page = ref(1)
const itemsPerPage = 10

const totalPages = computed(() => {
  return Math.ceil(props.tournaments.length / itemsPerPage)
})

const paginatedTournaments = computed(() => {
  const start = (page.value - 1) * itemsPerPage
  const end = start + itemsPerPage
  return props.tournaments.slice(start, end)
})

const getStateColor = (state) => {
  const stateColors = {
    'running': 'green',
    'archived': 'blue',
    'cancelled': 'grey',
    'draft': 'orange',
  }
  return stateColors[state] || 'grey'
}

</script>


<template>
  <div>
    <v-card>
      <v-card-title class="text-h5">
        {{ $t('tournaments.yourTournaments') }} 
      </v-card-title>
      
      <v-card-text>
        <v-list v-if="tournaments && tournaments.length > 0">
          <v-list-item
            v-for="tournament in paginatedTournaments"
            :key="tournament.id"
            class="mb-2"
            :to="{ name: 'tournament-show', params: { slug: tournament.slug } }"
          >
            <template v-slot:prepend>
              <v-avatar color="primary">
                <v-icon>mdi-trophy</v-icon>
              </v-avatar>
            </template>

            <v-list-item-title class="text-h6">
              {{ tournament.name }}
            </v-list-item-title>

            <v-list-item-subtitle>
              {{ tournament.description }}
            </v-list-item-subtitle>

            <template v-slot:append>
              <v-chip 
                :color="getStateColor(tournament.state)" 
                size="small"
              >
                {{ tournament.state }}
              </v-chip>
            </template>
          </v-list-item>
        </v-list>

        <v-alert
          v-else
          type="info"
          variant="tonal"
        >
          {{ $t('tournaments.noTournaments') }}
        </v-alert>

        <div v-if="totalPages > 1" class="d-flex justify-center mt-4">
          <v-pagination
            v-model="page"
            :length="totalPages"
            :total-visible="7"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>


<style scoped>
.v-list-item {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
</style>
